import { DriveInput } from "../types";
import { skipTourControls, skipFeedGuide, SkipFeedGuide } from "../helpers";
import { PureVoidFunc } from "../../helpers/functions/types";

export const introDriverTitle = "Welcome tour";
const introDriverSkip =
  "Skip guided tours (use default settings and demo data).";

const introDriverData: (skip: boolean) => DriveInput[] = (skip = false) => [
  {
    stepTitle: "Get Started",
    description:
      "This guided tour will give you an introduction in how to use the most important settings for search and recommendations. ",
  },
  {
    stepTitle: "Help Section",
    description: `The Welcome tour and all other tours can be accessed from the Help section. ${
      skip ? skipTourControls(introDriverSkip) : ""
    }`,
    anchorElement: "#Help",
  },
];

export const introGuide = (
  setSkip?: PureVoidFunc,
  skipData?: SkipFeedGuide,
) => {
  return {
    driverMenuItemTitle: introDriverTitle,
    driverData: {
      driverHeader: introDriverTitle,
      stepsData: introDriverData(!!skipData || !!setSkip),
      customSkip: () => {
        skipData && skipFeedGuide(skipData);
        setSkip && setSkip();
      },
    },
    steps: [],
  };
};
